const OPTIMIZE_SIGNUP_FLOW_AB_TEST = {
  test_name: "optimize_signup_flow",
  new_variation_name: "new_with_optimize_signup_flow",
  platform_key: "aa1012"
};

export default [OPTIMIZE_SIGNUP_FLOW_AB_TEST];
